var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelTiktok = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 55,
  height: 64,
  viewBox: "0 0 55 64",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M54.758 25.893q-.785.077-1.574.08a17.08 17.08 0 0 1-14.295-7.726v26.309C38.889 55.294 30.183 64 19.444 64 8.706 64 0 55.294 0 44.556 0 33.816 8.706 25.11 19.444 25.11c.406 0 .803.037 1.202.062v9.582c-.399-.048-.791-.121-1.202-.121-5.48 0-9.924 4.443-9.924 9.924s4.444 9.924 9.924 9.924c5.482 0 10.324-4.32 10.324-9.801L29.863 0h9.167a17.075 17.075 0 0 0 15.737 15.244v10.65"
})));
export default SvgChannelTiktok;